import React, { useState, useEffect, useContext } from 'react'
import { statusContext } from './config'
import ClosureDates from './ClosureDates'
import Checkbox from './Checkbox'

const List = (props) => {
  const status = useContext(statusContext)
  const { items, compute } = props;
  const [ showDates, setShowDates ] = useState(false)
  const [ showChildren, setShowChildren ] = useState()
  const itemsWithChildren = {}

  useEffect(() => {
    items.map(item => {
      if (!item.top) {
        itemsWithChildren[item.id] = false
      }
    })
    setShowChildren(itemsWithChildren)
  }, [])

  const toggleitemsWithChildren = (id) => {
    // switch the flag in the construct
    setShowChildren(prevState => {
      const newState = prevState
      newState[id] = !newState[id]
      return {...newState}
    })
  }

  return (
    <ul>
      {items && items.sort((a, b) => {
        const aWeight = a.weight ?? -1
        const bWeight = b.weight ?? -1
        return aWeight - bWeight
      }).map((item) => {
        let childList = null;

        if (Array.isArray(item.items)) {
          childList = <List items={item.items} filterType={props.filterType} setActiveFilter={props.setActiveFilter} map={props.map} compute={compute} setClosureActive={props.setClosureActive} closureActive={props.closureActive} setClosureDetails={props.setClosureDetails} />;
        }
        return (
          <li className={`sopa-map--categories_item ${item.id === 'road_closures' && 'sopa--map-list-item_road_closures'}`} key={item.id}>
            <label data-status={item.status} data-indeterminate={item.status === status.indeterminate}>
              <Checkbox
                id={item.id}
                name={item.id}
                status={props.status}
                setActiveFilter={props.setActiveFilter}
                filterType={props.filterType}
                setClosureActive={props.setClosureActive}
                checked={item.status === status.checked}
                indeterminate={item.status === status.indeterminate}
                compute={compute}
                items={item.items}
                className="sopa-map--categories_item-input"
              />
              <span className="sopa-map--categories_item-label">
                {
                  !item.top && item.items &&
                  <span className="sopa-map--categories_expando" aria-controls={`expand-${item.id}`}
                    onClick={(event) => {
                      event.preventDefault();
                      toggleitemsWithChildren(item.id)
                    }}
                    dangerouslySetInnerHTML={{ __html: `<span class="nsw-material-icons material-icons">${showChildren[item.id] ? 'remove' : 'add'}</span>` }}
                  />
                }
                {
                  !item.items && item.icon &&
                  <img className="sopa-map--categories_icon" src={item.icon} alt="" />
                }
                {item.name}
              </span>
            </label>
            {
              item.id === 'road_closures' && item.status === status.checked && <button type="button" disabled={!(item.status === status.checked) } onClick={() => { setShowDates(!showDates) }} className="nsw-button--two-outline nsw-button sopa-map--categories_select-date">
                <span className="nsw-material-icons material-icons">calendar_month</span>
                <span>Select date</span>
              </button>
            }
            {item.id === 'road_closures' && showDates && <ClosureDates setClosureActive={props.setClosureActive} closureActive={props.closureActive} setClosureDetails={props.setClosureDetails} map={props.map} setShowDates={setShowDates} checked={item.status === status.checked} showDates={showDates} />}
            {item.items &&
              <div id={`expand-${item.id}`} className={`sopa-map--panel_option-wrapper ${item.top  || showChildren[item.id] ? 'active' : 'inactive'}`} aria-hidden={`${item.top || showChildren[item.id] ? false : true}`} >
                {childList}
              </div>
            }
          </li>
        );
      })}
    </ul>
  );
}

export default List
